import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
    components: {
        Checkbox: {
            baseStyle: {
                container: {
                    touchAction: 'none',
                }
            }
        }
    },
    initialColorMode: "dark",
    useSystemColorMode: false,
    fonts: {
        heading: `'Ubuntu', sans`,
        body: `'Ubuntu', sans`,
    }
})


export default theme